import { useRightSidebar } from '~/layout/contexts/right-sidebar-layout/RightSidebarLayout';

/**
 * Renders the panel of the right sidebar's currently-active tab (or nothing
 * when collapsed). Placed inside the animated panel column in `SidebarLayout`.
 */
export const RightSidebarOutlet = () => {
  const { activePanel } = useRightSidebar();
  return <>{activePanel}</>;
};
